import { useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

const PostDetailHeader = ({ post, isOwner, onDelete, onReport }) => {
    const [menuOpen, setMenuOpen] = useState(false);

    const getProfileSrc = (path) => {
        if (!path) return "/public/noAvatar.png"; 
        return path.startsWith("http") ? path : "/upload/" + path;
    };

    return (
        <div className="user">
            <div className="userInfo">
                <img src={getProfileSrc(post.profilePic)} alt="" />
                
                <div className="details">
                    <Link 
                        to={`/profile/${post.userId}`} 
                        style={{ textDecoration: "none", color: "inherit" }}
                    >
                        <span className="name">
                            {post.name}
                        </span>
                    </Link>

                    <span className="date">
                        {moment(post.createdAt).fromNow()}
                    </span>
                </div>
            </div>

            <div className="menuContainer">
                <MoreHorizIcon 
                    onClick={() => setMenuOpen(!menuOpen)} 
                    className="iconMore" 
                    style={{ cursor: "pointer" }}
                />
                
                {/* {menuOpen && isOwner && (
                    <button onClick={onDelete} className="deleteBtn">
                        Delete Post
                    </button>
                )} */}

                {menuOpen && (
                    <div className="dropdownMenu">
                        {isOwner ? (
                            <div className="menuItem delete" onClick={() => { onDelete(); setMenuOpen(false); }}>
                                {/* <DeleteIcon fontSize="small" /> */}

                                <span className="deleteBtn">
                                    Delete Post
                                </span>
                            </div>
                        ) : (
                            <div className="menuItem report" onClick={() => { onReport(); setMenuOpen(false); }}>
                                {/* <ReportProblemOutlinedIcon fontSize="small" /> */}

                                <span className="deleteBtn">
                                    Report Post
                                </span>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PostDetailHeader;